/**
 * <materials-dropdown> — the "Available in N other materials" toggle on the product page.
 *
 * The button opens and closes the list; a click anywhere else, Escape, or the focus leaving the
 * element closes it. The rows are plain links, so without scripting the list is simply shown.
 * The first row is the material being viewed; choosing it closes the list and hands focus back.
 */
class MaterialsDropdown extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.materials-dropdown__toggle');
    this.list = this.querySelector('.materials-dropdown__list');
    if (!this.toggle || !this.list) return;
    this.toggle.addEventListener('click', this.onToggle);
    this.querySelector('.materials-dropdown__row--current')?.addEventListener('click', this.onCurrent);
    this.addEventListener('keydown', this.onKeydown);
    this.addEventListener('focusout', this.onFocusout);
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.onDocumentClick);
  }

  get open() {
    return this.toggle.getAttribute('aria-expanded') === 'true';
  }

  set open(value) {
    this.toggle.setAttribute('aria-expanded', String(value));
    this.list.hidden = !value;
  }

  onToggle = () => {
    this.open = !this.open;
  };

  onCurrent = () => {
    this.open = false;
    this.toggle.focus();
  };

  onKeydown = (event) => {
    if (event.key !== 'Escape' || !this.open) return;
    event.preventDefault();
    this.open = false;
    this.toggle.focus();
  };

  onFocusout = (event) => {
    if (this.open && event.relatedTarget && !this.contains(event.relatedTarget)) this.open = false;
  };

  onDocumentClick = (event) => {
    if (this.open && !this.contains(event.target)) this.open = false;
  };
}

if (!customElements.get('materials-dropdown')) customElements.define('materials-dropdown', MaterialsDropdown);
